"use client";
import EnrollLink from "./EnrollLink";
import type { CourseEnrollButtonProps } from "./types";

function CourseEnrollButton(props: CourseEnrollButtonProps) {
  return <EnrollLink {...props} />;
}

export default CourseEnrollButton;
